import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Spinner from '../../components/Spinner';
import FormImpresa from './FormImpresa';
import TabDatiEconomici from './tabs/TabDatiEconomici';
import TabRiepilogo from './tabs/TabRiepilogo';
import TabLRDT from './tabs/TabLRDT';

const TABS = ['Anagrafica', 'Legali Rapp. e Dir. Tecnici', 'Dati economici', 'Riepilogo dati economici'];

export default function SchedaImpresa() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [impresa, setImpresa] = useState(null);
  const [loading, setLoading] = useState(id !== 'nuova');
  const [tab, setTab] = useState(0);

  function caricaImpresa() {
    if (id === 'nuova') return;
    axios.get(`/api/imprese/${id}`)
      .then(r => setImpresa(r.data))
      .finally(() => setLoading(false));
  }

  useEffect(() => { caricaImpresa(); }, [id]);

  if (id === 'nuova') return <FormImpresa />;

  if (loading) return <Spinner />;
  if (!impresa) return <p className="text-red-600">Impresa non trovata</p>;

  return (
    <div>
      {/* Header */}
      <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
        <div>
          <button onClick={() => navigate(`/admin/gruppo-impresa/${encodeURIComponent(impresa.ragione_sociale)}`)} className="text-[#2E6096] hover:underline text-sm">← {impresa.ragione_sociale}</button>
          <h1 className="text-xl sm:text-2xl font-bold text-[#1A3A5C] mt-1">{impresa.ragione_sociale}</h1>
          <p className="text-gray-500 text-sm">{impresa.citta} {impresa.provincia ? `(${impresa.provincia})` : ''} — P.IVA {impresa.partita_iva || '—'}</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => navigate(`/admin/imprese/${id}/modifica`)}
            className="bg-[#1A3A5C] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#2E6096] transition"
          >
            Modifica anagrafica
          </button>
          <button
            onClick={async () => {
              if (!window.confirm(`Eliminare definitivamente "${impresa.ragione_sociale}" e tutti i suoi dati?`)) return;
              await axios.delete(`/api/imprese/${id}`);
              navigate('/admin/imprese');
            }}
            className="border border-red-300 text-red-600 px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-50 transition"
          >
            Elimina
          </button>
        </div>
      </div>

      {/* Tabs — scrollabili su mobile */}
      <div className="flex gap-1 mb-4 border-b border-gray-200 overflow-x-auto">
        {TABS.map((t, i) => (
          <button
            key={t}
            onClick={() => setTab(i)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition whitespace-nowrap ${
              tab === i
                ? 'border-[#1A3A5C] text-[#1A3A5C]'
                : 'border-transparent text-gray-500 hover:text-[#1A3A5C]'
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {tab === 0 && <TabAnagrafica impresa={impresa} />}
      {tab === 1 && <TabLRDT impresaId={id} impresa={impresa} />}
      {tab === 2 && <TabDatiEconomici impresaId={id} impresa={impresa} onImpresaAggiornata={caricaImpresa} />}
      {tab === 3 && <TabRiepilogo impresaId={id} impresa={impresa} />}
    </div>
  );
}

function TabAnagrafica({ impresa }) {
  function fmt(val, tipo) {
    if (!val) return '—';
    if (tipo === 'date') return new Date(val).toLocaleDateString('it-IT');
    if (tipo === 'bool') return val ? 'Sì' : 'No';
    return val;
  }

  const righe = [
    ['Ragione sociale', impresa.ragione_sociale],
    ['Indirizzo', impresa.indirizzo],
    ['Città', impresa.citta],
    ['CAP', impresa.cap],
    ['Provincia', impresa.provincia],
    ['Partita IVA', impresa.partita_iva],
    ['Codice fiscale', impresa.codice_fiscale],
    ['CCIAA di', impresa.camera_commercio_di],
    ['N° iscrizione CCIAA', impresa.iscrizione_cciaa],
    ['Data iscrizione CCIAA', fmt(impresa.data_iscrizione_cciaa, 'date')],
    ['Email', impresa.email],
    ['Data attestazione', fmt(impresa.data_attestazione, 'date')],
    ['SOA', impresa.soa],
    ['Codice di accesso', impresa.codice_accesso],
    ['Data contratto', fmt(impresa.data_contratto, 'date')],
    ['Indice ISTAT ultimo', impresa.indice_istat_ultimo],
    ['Incremento ISO 9001', fmt(impresa.incremento_iso, 'bool')],
    ['Abbattimento', fmt(impresa.abbattimento, 'bool')],
    ['N° richiesta', impresa.numero_richiesta],
  ];

  return (
    <div className="bg-white rounded-xl shadow overflow-hidden">
      <table className="w-full text-sm">
        <tbody>
          {righe.map(([label, val], i) => (
            <tr key={label} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              <td className="px-4 py-2.5 font-medium text-gray-600 w-48">{label}</td>
              <td className="px-4 py-2.5 text-gray-800">{val || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
